import React, { useEffect, useContext } from 'react';
import { PropTypes } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { useReviewSentiments, useReviews } from '@thd-nucleus/data-sources';
import { useReviewSentimentsDeprecated, useReviewsDeprecated } from "@thd-nucleus/data-sources/react/dataModel/migration";
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Rating } from '@thd-olt-component-react/rating';
import { dataModel } from '../ReviewDataModel';
import './BrandRating.scss';
import * as analytics from '../../ratings-reviews-analytics';
import BrandRatingModel from './BrandRatingModel';

export const BrandRating = ({ parentNode, itemId, brandName }) => {
  const { channel } = useContext(ExperienceContext);

  const variables = {
    filters: {
      isVerifiedPurchase: false,
      prosCons: null,
      starRatings: null
    },
    searchTerm: null,
    sortBy: 'photoreview',
    startIndex: 1
  };

  const { data: rData, error: rError, loading: rLoading } = useReviewsDeprecated({ itemId, variables });

  const { data: sData, error: sError, loading: sLoading } =
    useReviewSentimentsDeprecated({ itemId });

  const model = new BrandRatingModel(sData, rData);

  useEffect(() => {
    if (parentNode && !model.errors) {
      parentNode && parentNode.classList.add("brand-rating-flex");
    }
  }, [parentNode, rData, sData]);

  if ((rError && !rData) || !rData || rLoading) {
    return null;
  }

  if ((sError && !sData) || !sData || sLoading) {
    return null;
  }

  if (model.errors) {
    return null;
  }

  const handleOnShow = () => {
    analytics.track('event', {
      origin: 'ratings and reviews',
      location: 'zone a',
      value: 'brand rating',
    })
  };

  const formatBrandTotal = (total) => {
    if (total > 9999) {
      return `${Math.round(total/100)/10}k`
    } else {
      return total.toString()
    }
  };

  const { totalReviewCount, averageBrandRating, skuReviewCount } = model;
  const averageRatingText = averageBrandRating.toFixed(1);

  if (totalReviewCount <= skuReviewCount) {
    return null
  }

  return (
    <span className="brand-rating">
      (Brand Rating: {averageRatingText}/5)
      <Tooltip
        channel="desktop"
        interactive
        distance={15}
        placement="bottom"
        onShow={handleOnShow}
        triggerTarget={ channel === 'mobile' ? parentNode : this }
        content={
          <div className="brand-rating-wrapper">
            <div className="brand-rating-bold">
              Brand Rating
            </div>
            <div className="brand-rating-reviews">
              <Rating value={averageBrandRating}/>
              <span className="review-count">({formatBrandTotal(totalReviewCount)})</span>
            </div>
            <div>
              On average, customers rated <br/>
              <span className="brand-rating-bold">
                {brandName}
              </span>
              &nbsp;products
              <span className="brand-rating-bold">
              &nbsp;{averageRatingText}
              </span>
              &nbsp;out of
              <span className="brand-rating-bold">
              &nbsp;5
              </span>
              &nbsp;stars overall.
            </div>
          </div>
        }
      >
        <span className="brand-rating-info-icon"></span>
      </Tooltip>
    </span>
  );
};

let HTMLDivElement = null;
try {
  HTMLDivElement = window.HTMLDivElement;
} catch (e) {}

BrandRating.propTypes = {
  parentNode: PropTypes.instanceOf(HTMLDivElement),
  itemId: PropTypes.string,
  brandRating: PropTypes.string,
};

BrandRating.defaultProps = {
  parentNode: null,
  itemId: null,
  brandRating: '',
};

BrandRating.dataModel = {
  reviewSentiments: dataModel.reviewSentiments,
  reviews: dataModel.reviews
};
